import React, { Component } from "react";
import { Badge, Layout, Menu, message, notification } from "antd";
import {
  AppstoreAddOutlined,
  ClusterOutlined,
  CustomerServiceOutlined,
  LogoutOutlined,
  MenuOutlined,
  QuestionOutlined,
  RobotOutlined,
  SafetyCertificateOutlined,
  SettingFilled,
  TeamOutlined,
  UserOutlined
} from "@ant-design/icons";
import { connect } from "react-redux";
import { logout } from "../../store/actions/user";
import { Switch, Route, NavLink } from "react-router-dom";
import logoHorizontal from "../../assets/Biwo_Horizontal.png";
import Empresas from "./Empresas/Empresas";
import Perfiles from "./Perfiles/Perfiles";
import Usuarios from "./Usuarios/Usuarios";
import ModalItem from "../../Components/ModalItem";
import Facturacion from "./Facturacion/Facturacion";
import ScrollToTopItem from "../../Components/ScrollToTopItem";
import Configuracion from "./Configuracion/Configuracion";
import IA from "./IA/IA";
import { Drawer } from "antd5";
import ModalVersion from "./ModalVersion/ModalVersion";
import IconBiwo from "../../Icons/IconBiwo";
import IconBiwo2 from "../../Icons/IconBiwo2";
import EmpresasBiwo from "./EmpresasBiwo/EmpresasBiwo";
import CobroMasterBiwo from "./EmpresasBiwo/CobroBiwo/CobroMasterBiwo";
import UsuariosBiwo from "./UsuariosBiwo/UsuariosBiwo";
import MiPlanBiwo from "./MiPlanBiwo/MiPlanBiwo";

import FamiliasImplementacion from "./FamiliasImplementacion/FamiliasImplementacion";
import Permisos from "./Permisos/Permisos";
import Apariencias from "./Apariencias/AparienciasBiwo";
import CXCImplementacion from "./CXCImplementacion/CXCImplementacion";
import CXPImplementacion from "./CXPImplementacion/CXPImplementacion";
import DescargasSat from "./DescargasSat/DescargasSat";
import ImportarSatEntidades from "./ImportarSatEntidades/ImportarSatEntidades";
import Performance from "./Performance/Performance";
import Sesiones from "./Sesiones/Sesiones";
import Diagnostico from "./Diagnostico/Diagnostico";
import ErroresTimbrado from "./ErroresTimbrado/ErroresTimbrado";
import TicketsSoporte from "./TicketsSoporte/TicketsSoporte";
import DashboardSoporte from "./TicketsSoporte/DashboardSoporte";
import BurbujaSoporteGlobal from "../Panel/Soporte/Chat/BurbujaSoporteGlobal";
import ModalSubidosSoporte from "../Panel/Soporte/Chat/ModalSubidosSoporte";
import { consultarAccesoSoporte } from "../Panel/Soporte/Chat/accesoSoporte";
import { abrirWsSoporte } from "../Panel/Soporte/Chat/conexionWsSoporte";
import { MANUALES_POR_MODULO, abrirManual } from "../../Components/manualesAyuda";
import ModalDosPasos from "./DosPasos/ModalDosPasos";
import ModalAvisosBlog from "./ModalAvisosBlog/ModalAvisosBlog";
import axios from "axios";

const { SubMenu } = Menu;

const { Header, Footer, Content, Sider } = Layout;

class PanelPrincipal extends Component {
  state = {
    loading: false,
    collapsed: true,
    openKeys: [],
    isMobile: window.innerWidth <= 1000,
    mostrarChangelog: false,
    changelogVersion: null,
    modalLogout: false,
    soporteBurbujaAbierta: false,
    soporteNoLeidos: 0,
    permisoSoporte: false,
    puedeRevisarSoporte: false,
    soporteSubidos: [],
    tieneIa: false,
    modalDosPasos: false,
    avisosBlogPendientes: [],
  };

  componentDidMount() {
    if (this.props.history.location.pathname === '/panelPrincipal') {
      this.props.history.push(this.props.match.url + "/empresas");
    }

    Object.keys(sessionStorage).forEach(key => {
      if (key.startsWith("empresa_")) {
        sessionStorage.removeItem(key);
      }
    });


    if (this.props.mostrarChangelog && this.props.changelogVersion) {
      this.setState({
        mostrarChangelog: true,
        changelogVersion: this.props.changelogVersion
      })
    }

    this.consultarAvisosBlog();

    consultarAccesoSoporte({
      tipo: this.props.tipo,
      usuarioId: this.props.usuarioId,
      headersToken: this.props.headersToken,
      forzar: true,
    }).then(({ puede, puedeRevisar }) => {
      if (this._desmontado) return;
      this.setState({ permisoSoporte: puede || puedeRevisar, puedeRevisarSoporte: puedeRevisar });
      if (!puede && !puedeRevisar) return;
      this.cerrarWsSoporte = abrirWsSoporte({ empresaId: this.props.empresaId, usuarioId: this.props.usuarioId });
      if (puede) this.consultarSubidosSoporte();
    });

    this.consultarTieneIa();
  }

  consultarTieneIa = async () => {
    if (this.props.tipo !== 0 && !this.props.permisoAccesoEmpresasIa && !this.props.permisoAccesoUsuariosIa && !this.props.permisoAccesoBitacoraIa) return;
    try {
      const res = await axios.post("ia/tieneEmpresasIa", {}, { headers: this.props.headersToken });
      this.setState({ tieneIa: res.data?.success === 2 && res.data.tieneIa === true });
    } catch (error) {
      this.setState({ tieneIa: false });
    }
  };

  consultarSubidosSoporte = async () => {
    try {
      const res = await axios.post("soporte/subidosPendientes", {}, { headers: this.props.headersToken });
      if (res.data?.success === 2 && res.data.tickets?.length) {
        this.setState({ soporteSubidos: res.data.tickets });
      }
    } catch (error) {
      // Silencioso: si falla, el usuario igual ve sus reportes en el tablero.
    }
  };

  cerrarModalSubidosSoporte = async () => {
    const ticketIds = this.state.soporteSubidos.map((t) => t._id);
    this.setState({ soporteSubidos: [] });
    try {
      await axios.post("soporte/marcarSubidosVistos", { ticketIds }, { headers: this.props.headersToken });
    } catch (error) {
      // Si no se pudo marcar, vuelve a aparecer en el siguiente inicio de sesión.
    }
  };

  consultarAvisosBlog = async () => {
    try {
      const res = await axios.post("blogs/avisosPendientes", {}, { headers: this.props.headersToken });
      if (res.data?.success === 2 && res.data.avisos?.length) {
        this.setState({ avisosBlogPendientes: res.data.avisos });
      }
    } catch (error) {
      // Silencioso: si falla, se reintenta en el siguiente inicio de sesión.
    }
  };

  cerrarModalAvisosBlog = async () => {
    const avisoIds = this.state.avisosBlogPendientes.map((a) => a._id);
    this.setState({ avisosBlogPendientes: [] });
    try {
      await axios.post("blogs/marcarAvisosVistos", { avisoIds }, { headers: this.props.headersToken });
    } catch (error) {
      // Si no se pudo marcar, vuelve a aparecer en el siguiente inicio de sesión.
    }
  };

  componentWillUnmount() {
    this._desmontado = true;
    if (this.cerrarWsSoporte) this.cerrarWsSoporte();
  }

  onCollapse = (collapsed) => {
    this.setState({ collapsed });
  };

  abrirModalLogout = () => {
    this.setState({ modalLogout: true });
  };

  cerrarModalLogout = () => {
    this.setState({ modalLogout: false });
  };

  cerrarModal = () => {
    this.setState({ mostrarChangelog: false });
  };

  mostrarBotonSoporte = (ruta) =>
    this.state.permisoSoporte && !this.state.isMobile && !String(ruta).endsWith("/ticketsSoporte");

  alternarBurbujaSoporte = () =>
    this.setState((prev) => ({ soporteBurbujaAbierta: !prev.soporteBurbujaAbierta }));

  actualizarNoLeidosSoporte = (soporteNoLeidos) => this.setState({ soporteNoLeidos });

  logout = () => {
    this.props.logout().then((response) => {
      if (response.success === 1) {
        this.setState({ modalLogout: false });
        this.props.history.push("/login");

        notification.info({
          message: 'Se ha cerrado la sesión',
          duration: 0.7,
        });

      } else {
        message.warning(response.err, 2);
      }
    });
  };

  onOpenChange(keys) {
    const latestOpenKey = keys.find(
      (key) => this.state.openKeys.indexOf(key) === -1
    );
    this.setState({ openKeys: latestOpenKey ? [latestOpenKey] : [] });
  }

  toggleDrawer = () => {
    this.setState((prevState) => ({ drawerVisible: !prevState.drawerVisible }));
  };

  render() {
    const current = this.props.history.location.pathname;


    const menuItems = (
      <>
        <Menu.Item
          key={this.props.match.url + "/empresas"}
          icon={<ClusterOutlined />}
        >
          <NavLink to={this.props.match.url + "/empresas"}>
            Empresas
          </NavLink>
        </Menu.Item>
        {(this.props.usuarioId?.toString() === "60c790904bb9710b10b079d3" || this.props.usuarioId?.toString() === "6351860084feb50016c6097f") && (
          <SubMenu
            key={
              this.props.match.url + "/empresasBiwo" ||
              this.props.match.url + "/familiasImplementacion" ||
              this.props.match.url + "/permisos"
            }
            title="Biwo"
            icon={<IconBiwo />}
          >
            <Menu.Item
              key={this.props.match.url + "/empresasBiwo"}
              icon={<IconBiwo2 />}
            >
              <NavLink to={this.props.match.url + "/empresasBiwo"}>
                Empresas
              </NavLink>
            </Menu.Item>
            <Menu.Item
              key={this.props.match.url + "/usuariosBiwo"}
              icon={<IconBiwo2 />}
            >
              <NavLink to={this.props.match.url + "/usuariosBiwo"}>
                Usuarios
              </NavLink>
            </Menu.Item>
            <Menu.Item
              key={this.props.match.url + "/familiasImplementacion"}
              icon={<IconBiwo2 />}
            >
              <NavLink to={this.props.match.url + "/familiasImplementacion"}>
                Familias Imp.
              </NavLink>
              
            </Menu.Item>
             <Menu.Item
              key={this.props.match.url + "/permisos"}
              icon={<IconBiwo2 />}
            >
              <NavLink to={this.props.match.url + "/permisos"}>
                Permisos
              </NavLink>
            </Menu.Item>
             <Menu.Item
              key={this.props.match.url + "/sesiones"}
              icon={<IconBiwo2 />}
            >
              <NavLink to={this.props.match.url + "/sesiones"}>
                Sesiones
              </NavLink>
            </Menu.Item>
             <Menu.Item
              key={this.props.match.url + "/apariencias"}
              icon={<IconBiwo2 />}
            >
              <NavLink to={this.props.match.url + "/apariencias"}>
                Apariencias
              </NavLink>
            </Menu.Item>
            <Menu.Item
              key={this.props.match.url + "/cxcImplementacion"}
              icon={<IconBiwo2 />}
            >
              <NavLink to={this.props.match.url + "/cxcImplementacion"}>
                CXC Imp.
              </NavLink>
            </Menu.Item>
            <Menu.Item
              key={this.props.match.url + "/cxpImplementacion"}
              icon={<IconBiwo2 />}
            >
              <NavLink to={this.props.match.url + "/cxpImplementacion"}>
                CXP Imp.
              </NavLink>
            </Menu.Item>
            <Menu.Item
              key={this.props.match.url + "/performance"}
              icon={<IconBiwo2 />}
            >
              <NavLink to={this.props.match.url + "/performance"}>
                Performance
              </NavLink>
            </Menu.Item>
            <Menu.Item
              key={this.props.match.url + "/descargasSat"}
              icon={<IconBiwo2 />}
            >
              <NavLink to={this.props.match.url + "/descargasSat"}>
                Descargas SAT
              </NavLink>
            </Menu.Item>
            <Menu.Item
              key={this.props.match.url + "/importarSatEntidades"}
              icon={<IconBiwo2 />}
            >
              <NavLink to={this.props.match.url + "/importarSatEntidades"}>
                Importar desde SAT
              </NavLink>
            </Menu.Item>
            <Menu.Item
              key={this.props.match.url + "/diagnostico"}
              icon={<IconBiwo2 />}
            >
              <NavLink to={this.props.match.url + "/diagnostico"}>
                Diagnóstico
              </NavLink>
            </Menu.Item>
            <Menu.Item
              key={this.props.match.url + "/erroresTimbrado"}
              icon={<IconBiwo2 />}
            >
              <NavLink to={this.props.match.url + "/erroresTimbrado"}>
                Rechazos del PAC
              </NavLink>
            </Menu.Item>
            <Menu.Item
              key={this.props.match.url + "/ticketsSoporte"}
              icon={<IconBiwo2 />}
            >
              <NavLink to={this.props.match.url + "/ticketsSoporte"}>
                Tickets de Soporte
              </NavLink>
            </Menu.Item>
            <Menu.Item
              key={this.props.match.url + "/dashboardSoporte"}
              icon={<IconBiwo2 />}
            >
              <NavLink to={this.props.match.url + "/dashboardSoporte"}>
                Métricas de Soporte
              </NavLink>
            </Menu.Item>
          </SubMenu>
        )}
        {this.props.permisoAccesoPerfiles &&
          <Menu.Item
            key={this.props.match.url + "/perfiles"}
            icon={<UserOutlined />}
          >
            <NavLink to={this.props.match.url + "/perfiles"}>
              Perfiles
            </NavLink>
          </Menu.Item>
        }
        {this.props.permisoAccesoUsuarios &&
          <Menu.Item
            key={this.props.match.url + "/usuarios"}
            icon={<TeamOutlined />}
          >
            <NavLink to={this.props.match.url + "/usuarios"}>
              Usuarios
            </NavLink>
          </Menu.Item>
        }
        {this.props.permisoMiPlanBiwo &&
          <Menu.Item
            key={this.props.match.url + "/miPlanBiwo"}
            icon={<AppstoreAddOutlined />}
          >
            <NavLink to={this.props.match.url + "/miPlanBiwo"}>
              Mi plan BIWO
            </NavLink>
          </Menu.Item>
        }
        {/*<Menu.Item
          key={this.props.match.url + "/facturacion"}
          icon={<CreditCardOutlined />}
        >
          <NavLink to={this.props.match.url + "/facturacion"}>
            Facturacion
          </NavLink>
        </Menu.Item>*/}
        <Menu.Item
          key={this.props.match.url + "/configuracion"}
          icon={<SettingFilled />}
        >
          <NavLink to={this.props.match.url + "/configuracion"}>
            Configuracion
          </NavLink>
        </Menu.Item>
        {(this.props.tipo === 0 || this.props.permisoAccesoEmpresasIa || this.props.permisoAccesoUsuariosIa || this.props.permisoAccesoBitacoraIa) && this.state.tieneIa &&
          <Menu.Item
            key={this.props.match.url + "/ia"}
            icon={<RobotOutlined />}
          >
            <NavLink to={this.props.match.url + "/ia"}>
              IA
            </NavLink>
          </Menu.Item>
        }
      </>
    )

    return (
      <>
        <Layout>
          <Header id="header-fixed">
            <Menu
              mode="horizontal"
              selectedKeys={current}
              style={{ height: "100%" }}
              id="menu-centered"
            >
              {this.state.isMobile &&
                <Menu.Item
                  key={6}
                  icon={<LogoutOutlined style={{ fontSize: 20 }} />}
                  onClick={this.abrirModalLogout.bind(this)}
                />
              }
              <Menu.Item key={"/login"} id="menuitem-izquierda">
                <img src={logoHorizontal} alt="Logo" id="img-logo" />
              </Menu.Item>
              {this.state.isMobile ?
                <Menu.Item
                  key={0}
                  icon={<MenuOutlined style={{ fontSize: 20 }} />}
                  onClick={this.toggleDrawer.bind(this)}
                />
                :
                <Menu.Item
                  key="3"
                  id="menuitem"
                  style={{ paddingLeft: "20px", paddingRight: "20px" }}
                  icon={<LogoutOutlined />}
                  onClick={this.abrirModalLogout.bind(this)}
                >
                  Cerrar Sesión
                </Menu.Item>
              }
              {this.mostrarBotonSoporte(current) &&
                <Menu.Item
                  key="soporteBarra"
                  id="menuitem"
                  style={{ paddingLeft: "20px", paddingRight: "20px" }}
                  icon={<CustomerServiceOutlined />}
                  onClick={this.alternarBurbujaSoporte}
                >
                  <Badge count={this.state.soporteNoLeidos} overflowCount={99} offset={[10, 0]}>
                    Soporte
                  </Badge>
                </Menu.Item>
              }
              {!this.state.isMobile &&
                <Menu.Item
                  key="dosPasos"
                  id="menuitem"
                  style={{ paddingLeft: "20px", paddingRight: "20px" }}
                  icon={<SafetyCertificateOutlined />}
                  onClick={() => this.setState({ modalDosPasos: true })}
                >
                  Verificación en dos pasos
                </Menu.Item>
              }
              {!this.state.isMobile && this.state.tieneIa &&
                <Menu.Item
                  key="manualIa"
                  id="menuitem"
                  style={{ paddingLeft: "20px", paddingRight: "20px" }}
                  icon={<QuestionOutlined />}
                  onClick={() => abrirManual(MANUALES_POR_MODULO.iaUsuario[0])}
                >
                  Manual de IA
                </Menu.Item>
              }
            </Menu>
          </Header>
          <Layout>
            {this.state.isMobile ?
              <Drawer
                title="Menu"
                placement="left"
                onClose={this.toggleDrawer}
                open={this.state.drawerVisible}
                bodyStyle={{ padding: 0 }}
                width={300}
              >
                <Menu
                  mode="inline"
                  theme="light"
                  openKeys={this.state.openKeys}
                  selectedKeys={current}
                  onOpenChange={this.onOpenChange.bind(this)}
                >
                  {menuItems}
                  <Menu.Item icon={<SafetyCertificateOutlined />} key="dosPasos" onClick={() => this.setState({ modalDosPasos: true, drawerVisible: false })}>
                    Verificación en dos pasos
                  </Menu.Item>
                  <Menu.Item icon={<LogoutOutlined />} style={{ color: 'red' }} key="3" onClick={this.abrirModalLogout.bind(this)}>
                    Cerrar Sesion
                  </Menu.Item>
                </Menu>
              </Drawer>
              :
              <Sider
                collapsible={window.innerWidth > 1000 ? true : false}
                collapsed={window.innerWidth > 1000 ? this.state.collapsed : true}
                onCollapse={window.innerWidth > 1000 ? this.onCollapse : () => { }}
                style={{ marginTop: "64px", minHeight: window.innerHeight - 64 }}
              >
                <Menu
                  selectedKeys={current}
                  mode="inline"
                  theme="dark"
                  defaultSelectedKeys={[this.props.match.url + "/empresas"]}
                  openKeys={this.state.openKeys}
                  onOpenChange={this.onOpenChange.bind(this)}
                >
                  {menuItems}
                </Menu>
              </Sider>
            }
            <Layout
              style={{
                marginRight: this.state.soporteBurbujaAbierta && !this.state.isMobile ? 380 : 0,
                transition: "margin-right 0.25s ease",
              }}
            >
              <Content id="content">
                <ScrollToTopItem />
                <Switch>
                  <Route
                    path={this.props.match.url + "/empresas"}
                    component={Empresas}
                  />
                  {this.props.permisoAccesoPerfiles &&
                    <Route
                      path={this.props.match.url + "/perfiles"}
                      component={Perfiles}
                    />
                  }
                  {this.props.permisoAccesoUsuarios &&
                    <Route
                      path={this.props.match.url + "/usuarios"}
                      component={Usuarios}
                    />
                  }
                  {this.props.permisoMiPlanBiwo &&
                    <Route
                      path={this.props.match.url + "/miPlanBiwo"}
                      component={MiPlanBiwo}
                    />
                  }
                  <Route
                    path={this.props.match.url + "/facturacion"}
                    component={Facturacion}
                  />
                  <Route
                    path={this.props.match.url + "/configuracion"}
                    component={Configuracion}
                  />
                  {(this.props.tipo === 0 || this.props.permisoAccesoEmpresasIa || this.props.permisoAccesoUsuariosIa || this.props.permisoAccesoBitacoraIa) && this.state.tieneIa &&
                    <Route
                      path={this.props.match.url + "/ia"}
                      component={IA}
                    />
                  }
                  {(this.props.usuarioId?.toString() === "60c790904bb9710b10b079d3" || this.props.usuarioId?.toString() === "6351860084feb50016c6097f") && (
                    <>
                      <Route
                        path={this.props.match.url + "/empresasBiwo"}
                        component={EmpresasBiwo}
                      />
                      <Route
                        path={this.props.match.url + "/cobroMasterBiwo/:usuarioId"}
                        component={CobroMasterBiwo}
                      />
                      <Route
                        path={this.props.match.url + "/usuariosBiwo"}
                        component={UsuariosBiwo}
                      />
                      <Route
                        path={this.props.match.url + "/familiasImplementacion"}
                        component={FamiliasImplementacion}
                      />
                      <Route
                        path={this.props.match.url + "/permisos"}
                        component={Permisos}
                      />
                      <Route
                        path={this.props.match.url + "/sesiones"}
                        component={Sesiones}
                      />
                      <Route
                        path={this.props.match.url + "/apariencias"}
                        component={Apariencias}
                      />
                      <Route
                        path={this.props.match.url + "/cxcImplementacion"}
                        component={CXCImplementacion}
                      />
                      <Route
                        path={this.props.match.url + "/cxpImplementacion"}
                        component={CXPImplementacion}
                      />
                      <Route
                        path={this.props.match.url + "/performance"}
                        component={Performance}
                      />
                      <Route
                        path={this.props.match.url + "/descargasSat"}
                        component={DescargasSat}
                      />
                      <Route
                        path={this.props.match.url + "/importarSatEntidades"}
                        component={ImportarSatEntidades}
                      />
                      <Route
                        path={this.props.match.url + "/diagnostico"}
                        component={Diagnostico}
                      />
                      <Route
                        path={this.props.match.url + "/erroresTimbrado"}
                        component={ErroresTimbrado}
                      />
                      <Route
                        path={this.props.match.url + "/ticketsSoporte"}
                        component={TicketsSoporte}
                      />
                      <Route
                        path={this.props.match.url + "/dashboardSoporte"}
                        component={DashboardSoporte}
                      />
                    </>
                  )}
                </Switch>
              </Content>
              <Footer id="content-background" style={{ textAlign: "center" }}>
                Biwo ©2026
              </Footer>
            </Layout>
          </Layout>
        </Layout>
        <ModalVersion
          visible={this.state.mostrarChangelog}
          version={this.state.changelogVersion}
          onClose={this.cerrarModal}
        />
        {/* En la página de tickets de soporte no se monta: ahí ya se ve todo en grande. */}
        {this.mostrarBotonSoporte(current) && (
          <BurbujaSoporteGlobal
            headersToken={this.props.headersToken}
            usuarioId={this.props.usuarioId}
            esMaster={this.props.tipo === 0}
            puedeRevisar={this.state.puedeRevisarSoporte}
            abierto={this.state.soporteBurbujaAbierta}
            onCerrar={() => this.setState({ soporteBurbujaAbierta: false })}
            onNoLeidos={this.actualizarNoLeidosSoporte}
          />
        )}
        <ModalSubidosSoporte
          visible={this.state.soporteSubidos.length > 0}
          tickets={this.state.soporteSubidos}
          onCerrar={this.cerrarModalSubidosSoporte}
        />
        <ModalDosPasos
          visible={this.state.modalDosPasos}
          onCancel={() => this.setState({ modalDosPasos: false })}
        />
        <ModalAvisosBlog
          visible={this.state.avisosBlogPendientes.length > 0}
          avisos={this.state.avisosBlogPendientes}
          onCerrar={this.cerrarModalAvisosBlog}
        />
        <ModalItem
          visible={this.state.modalLogout}
          onCancel={this.cerrarModalLogout}
          onOk={this.logout}
          width={400}
          footer
          okText="Cerrar Sesión"
          cancelText="Cancelar"
          titulo=""
          spinning={false}
        >
          <div style={{ padding: "20px 0", textAlign: "center" }}>
            <h3>¿Deseas cerrar sesión?</h3>
          </div>
        </ModalItem>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    usuarioId: state.user.usuarioId,
    tipo: state.user.tipo,
    empresaId: state.empresa.id,
    rfc: state.empresa.rfc,
    nombre: state.empresa.nombre,
    mostrarChangelog: state.user.mostrarChangelog,
    changelogVersion: state.user.changelogVersion,
    permisoAccesoPerfiles:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a2313c5903358dc7da8a899"
      )?.activado,
    permisoMiPlanBiwo:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6adba8ca39c47705eeea7b09"
      )?.activado,
    permisoAccesoUsuarios:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a231408903358dc7da8a8a8"
      )?.activado,
    permisoAccesoEmpresasIa:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6ad3a5cd2857d5048c4b38c4"
      )?.activado,
    permisoAccesoUsuariosIa:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6ad3a5dd2857d5048c4b38c5"
      )?.activado,
    permisoAccesoBitacoraIa:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6ad3a5e934886b04b07905e7"
      )?.activado,
  };
};

export default connect(mapStateToProps, { logout })(PanelPrincipal);
